module.exports = require('../_components/@alicd/next-button/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/button/index.js
// module id = 53
// module chunks = 0